import type { ReactNode } from 'react';
import InputField from '@savvy-kit/patterns/input-field';

export function sanitizeDecimal(raw: string, maxDecimals: number) {
  const digitsAndDots = raw.replace(/[^\d.]/g, '');
  const [whole = '', ...rest] = digitsAndDots.split('.');
  if (rest.length === 0 || maxDecimals === 0) {
    return whole;
  }
  return `${whole}.${rest.join('').slice(0, maxDecimals)}`;
}

type AddAccountNumericFieldProps = {
  readonly id: string;
  readonly label: string;
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly onBlur?: () => void;
  readonly maxDecimals: number;
  readonly required?: boolean;
  readonly autoFocus?: boolean;
  readonly description?: string;
  readonly errorMessage?: string;
  readonly prependInputAddon?: ReactNode;
  readonly appendInputAddon?: ReactNode;
};

export function AddAccountNumericField({
  id,
  label,
  value,
  onChange,
  onBlur,
  maxDecimals,
  required,
  autoFocus,
  description,
  errorMessage,
  prependInputAddon,
  appendInputAddon,
}: AddAccountNumericFieldProps) {
  return (
    <InputField
      id={id}
      label={label}
      value={value}
      onBlur={onBlur}
      onChange={(event) => {
        onChange(sanitizeDecimal(event.target.value, maxDecimals));
      }}
      required={required}
      autoFocus={autoFocus}
      description={description}
      inputMode="decimal"
      autoComplete="off"
      error={errorMessage !== undefined}
      errorMessage={errorMessage}
      prependInputAddon={prependInputAddon}
      appendInputAddon={appendInputAddon}
    />
  );
}
